import InputError from "@atoms/inputs/InputError/InputError";
import { cn } from "@util/helpers";
import parse from "html-react-parser";

/** Input field - checkbox */
const Checkbox = ({
  label,
  name,
  variantClassName,
  onHandleChange,
  errorMessage,
}: CheckboxFields): React.ReactElement => {
  const className = cn("flex items-start gap-3", variantClassName?.container);

  const handleChange = (value: string) => {
    if (!onHandleChange) return;
    onHandleChange(value);
  };

  return (
    <div
      className={cn("flex items-start gap-3 text-left", className)}
      data-testid="checkbox-component"
    >
      <input
        type="checkbox"
        className="h-4 w-4 flex-none cursor-pointer accent-gray-850"
        name={name}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      />

      <div>
        <p className="mb-0 font-poppins text-7xs font-normal leading-150 [&>a]:underline">
          {parse(label)}
        </p>

        {errorMessage ? (
          <InputError
            className="mb-0 font-poppins text-7xs font-normal leading-150"
            error={errorMessage}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Checkbox;
